<template>
  <div class="blueCircleWrapper">
  <div class="blueCircle">
    +{{myval}}{{myunit}}
  </div>
  </div>

</template>

<script>
export default {
  props:['myval','myunit'],
  computed: {
   
  }
}
</script>
